const BindingStatus = (binding) => {
    switch (binding) {
        default:
        case "":
            return ""
        case "BoundToAccount":
            return "BtA"
        case "BoundToCharacter":
            return "BtC"
    }
}

export default BindingStatus;